import { mergeDeepLeft } from 'ramda'

import {
  basicFetch,
  convertEndpointProviderToFetchArgs,
  createAuthHeaders,
  EndpointInterface,
  EndpointProviderDefaults,
  NetworkContextDefaults,
} from '@surglogs-app/network'

import { blobFetch } from './blobFetch'

export const createQueryEndpoint = <
  TResponse = any,
  TRequestBody extends Record<string, any> = Record<string, any>,
>(
  networkContext: NetworkContextDefaults,
  {
    endpoint,
    defaults,
    isBlob,
  }: {
    endpoint: EndpointInterface<TResponse, TRequestBody>
    defaults: EndpointProviderDefaults | undefined
    isBlob?: boolean
  },
) => {
  const { token, version, baseUrl, platform } = networkContext
  const fetcher = isBlob ? blobFetch : basicFetch

  return (params: { pageParam?: unknown } | undefined = {}) =>
    endpoint((data) =>
      fetcher(
        ...convertEndpointProviderToFetchArgs(
          mergeDeepLeft(defaults || {}, {
            baseUrl,
            version,
            platform,
            headers: token ? createAuthHeaders(token) : undefined,
          }),
        )({
          ...data,
          query: {
            ...data.query,
            ...(params.pageParam
              ? { [data.query?.cursor]: params.pageParam }
              : {}),
          },
        }),
      ),
    )
}
